import { render } from "./HolidayApprovalPanel.vue?vue&type=template&id=31287b07&scoped=true"
import script from "./HolidayApprovalPanel.vue?vue&type=script&lang=js"
export * from "./HolidayApprovalPanel.vue?vue&type=script&lang=js"

import "./HolidayApprovalPanel.vue?vue&type=style&index=0&id=31287b07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31287b07"]])

export default __exports__